import { WorkModule, Product } from '@/models/index'
export default class Utils {
  static dateToCleanISOFormat(dt: Date): string {
    return `${dt.getFullYear().toString().padStart(4, '0')}-${(
      dt.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}-${dt
      .getDate()
      .toString()
      .padStart(2, '0')} ${dt
      .getHours()
      .toString()
      .padStart(2, '0')}:${dt
      .getMinutes()
      .toString()
      .padStart(2, '0')}:${dt.getSeconds().toString().padStart(2, '0')}`
  }

  static getCurrentWorkModule(product: Product, workModuleCode: string) {
    let workModule: WorkModule
    if (product.id && product.workModules) {
      workModule = product.workModules.filter(
        (cwm: WorkModule) => workModuleCode === cwm.code
      )[0]
      return workModule
    }
  }

  /*
   * Returns size as 'Bytes', 'KB', 'MB', 'GB', 'TB' from bytes number with passed decimals
   */
  static bytesToSize(bytes: number, decimals = 0): string {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    if (bytes === 0) return '0 Byte'
    const i: number = Math.floor(Math.log(bytes) / Math.log(1024))
    const eplus = ('e+' + decimals).toString()
    const eminus = ('e-' + decimals).toString()
    const calculatedSize = bytes / Math.pow(1024, i)
    const size = (+(Math.round(Number(calculatedSize + eplus)) + eminus)).toFixed(decimals)
    return size + ' ' + sizes[i]
  }
}
